export default __webpack_public_path__ + "static/media/emoji-angry.877f81a6.svg";